import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function BedStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M21.95 12.05C21.89 11.99 21.82 11.93 21.75 11.89V7.36C21.75 6.61 21.75 6.12 21.46 5.61C21.17 5.13 20.78 4.88 20.19 4.52C17.78 3.03 14.95 2.25 12 2.25C9.05 2.25 6.22 3.03 3.81 4.52C3.22 4.89 2.83 5.13 2.55 5.61C2.25 6.11 2.25 6.61 2.25 7.36V11.9C2.18 11.93 2.12 11.99 2.06 12.05C1.25 12.86 1.25 13.97 1.25 16V21C1.25 21.41 1.59 21.75 2 21.75C2.41 21.75 2.75 21.41 2.75 21V18.25H21.25V21C21.25 21.41 21.59 21.75 22 21.75C22.41 21.75 22.75 21.41 22.75 21V16C22.75 13.97 22.75 12.86 21.95 12.05ZM3.75 7.36C3.75 6.76 3.75 6.52 3.84 6.37C3.93 6.22 4.11 6.1 4.6 5.8C6.77 4.46 9.33 3.75 12 3.75C14.67 3.75 17.23 4.46 19.4 5.8C19.89 6.1 20.07 6.21 20.16 6.37C20.25 6.52 20.25 6.76 20.25 7.36V11.33C19.82 11.27 19.33 11.26 18.75 11.26V10.21C18.75 9.72 18.66 9.23 17.99 8.88C16.34 8.04 14.66 8.04 13.01 8.88C12.34 9.22 12.25 9.72 12.25 10.21V11.25H11.75V10.21C11.75 9.72 11.66 9.23 10.99 8.88C9.34 8.04 7.66 8.04 6.01 8.88C5.34 9.22 5.25 9.72 5.25 10.21V11.26C4.67 11.26 4.18 11.27 3.75 11.33V7.36ZM17.25 11.25H13.75V10.19C14.93 9.61 16 9.58 17.25 10.19V11.25ZM10.25 11.25H6.75V10.19C7.93 9.61 9 9.58 10.25 10.19V11.25ZM21.25 16.75H2.75V16C2.75 14.25 2.77 13.46 3.12 13.11C3.47 12.76 4.26 12.75 6 12.75H18C19.75 12.75 20.53 12.76 20.89 13.11C21.24 13.46 21.25 14.25 21.25 16V16.75Z"
				fill="currentColor"
			/>
		</svg>
	);
}

BedStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default BedStrokeIcon;
